// A password field with a show / hide toggle (the sign-in page's own),
// for the set-password page and Settings → Password.

import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

import { Button } from "@/components/ui/Button";
import { Input, type InputProps } from "@/components/ui/Input";

export const PasswordInput = forwardRef<HTMLInputElement, Omit<InputProps, "type">>(function PasswordInput(
  { className, ...props },
  ref,
) {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <Input ref={ref} type={shown ? "text" : "password"} className={["pr-12", className].filter(Boolean).join(" ")} {...props} />
      <Button
        type="button"
        variant="ghost"
        size={props.fieldSize === "lg" ? "icon" : "icon-sm"}
        aria-label={shown ? "Hide password" : "Show password"}
        aria-pressed={shown}
        onClick={() => setShown((v) => !v)}
        className="absolute right-1 top-1/2 -translate-y-1/2"
      >
        {shown ? <EyeOff aria-hidden className="h-4 w-4" /> : <Eye aria-hidden className="h-4 w-4" />}
      </Button>
    </div>
  );
});
